import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { IPartAccessoryFormGroup } from '../../shared/models';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatExpansionModule } from '@angular/material/expansion';
import { ConfiguratorComponent } from '../../../plm/configurator/configurator.component';

@Component({
  selector: 'app-part-accessory-form-group',
  imports: [
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatExpansionModule,
    ConfiguratorComponent,
  ],
  templateUrl: './part-accessory-form-group.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './part-accessory-form-group.component.scss',
})
export class PartAccessoryFormGroupComponent {
  @Input() fg!: FormGroup<IPartAccessoryFormGroup>;
}
